import React from "react";
import { Link } from "react-router-dom";
import { Card, CardFooter, Button } from "../ui";
import { classPublicHref } from "../../lib/classLinks";

function formatWhen(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/**
 * Compact feed card for a followed class that still needs an RSVP.
 * Quiet DemoLandingCard rhythm: meta → title → detail → CTA.
 */
export default function ClassFeedCard({ item }) {
  const cls = item?.class || {};
  const school = item?.school || {};
  const href = item?.href
    || classPublicHref({
      schoolSlug: school.slug,
      classSlug: cls.slug,
    }, { date: item?.occurrence_date, rsvp: true })
    || (school.slug ? `/school/${school.slug}` : "/");

  return (
    <Card
      interactive
      className="p-0 overflow-hidden"
      data-testid={`class-feed-card-${item?.class_id || item?.id}`}
    >
      <Link to={href} className="block p-4 hover:bg-canvas/60 transition-colors">
        <p className="font-ui text-[12px] font-medium text-ink/50">
          {school.name ? `${school.name} · ` : ""}
          {formatWhen(item.occurrence_at)}
        </p>
        <h3 className="mt-1 font-ui font-semibold text-[16px] sm:text-[17px] leading-snug text-ink text-balance">
          {cls.name || "Class"}
        </h3>
        {(cls.style_tag || cls.level_tag) && (
          <p className="mt-1 font-ui text-[13px] font-medium text-ink/55">
            {[cls.style_tag, cls.level_tag].filter(Boolean).join(" · ")}
          </p>
        )}
      </Link>
      <CardFooter>
        <Button
          as={Link}
          to={href}
          variant="primary"
          className="min-h-[44px] px-4 text-[14px]"
          data-testid={`class-feed-rsvp-${item?.class_id}`}
        >
          RSVP →
        </Button>
      </CardFooter>
    </Card>
  );
}
